import React from 'react';
import { UnstyledButton } from '@mantine/core';
import { formatMoney } from '../../../../../../../utils/money';
import type { OrderReportGroupBreakdownRow } from '../shared/average-breakdown.utils';
import classes from './average-breakdown.module.scss';

type AverageBreakdownButtonProps = {
  average: string;
  rows: OrderReportGroupBreakdownRow[];
  isOpen: boolean;
  bottomItemClassName: string;
  bottomNumberClassName: string;
  bottomLabelClassName: string;
  onToggle: () => void;
};

export const AverageBreakdownButton = React.forwardRef<HTMLButtonElement, AverageBreakdownButtonProps>(
  ({ average, rows, isOpen, bottomItemClassName, bottomNumberClassName, bottomLabelClassName, onToggle }, ref) => (
    <UnstyledButton
      ref={ref}
      component="button"
      type="button"
      className={`${bottomItemClassName} ${classes.averageBottomItem}`}
      aria-label="ממוצע שולחן"
      aria-expanded={isOpen}
      data-testid="average-breakdown-toggle"
      onClick={onToggle}
    >
      {isOpen && (
        <span className={classes.averageBreakdownBubble} role="status">
          {rows.length > 0 ? (
            rows.map((row) => (
              <span key={row.key} className={classes.averageBreakdownRow}>
                <span>{row.label}:</span>
                <span className={classes.averageBreakdownAmount}>{formatMoney(row.amount)} ₪</span>
              </span>
            ))
          ) : (
            <span className={classes.averageBreakdownRow}>אין פריטים</span>
          )}
        </span>
      )}
      <span className={bottomNumberClassName}>{average}</span>
      <span className={bottomLabelClassName}>ממוצע</span>
    </UnstyledButton>
  ),
);

AverageBreakdownButton.displayName = 'AverageBreakdownButton';
